'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  return (
    <footer className="relative h-[600px] md:h-[450px]">
      <div className="absolute w-full h-[600px] md:h-[450px]">
        <Image
          src="/assets/images/footer_image.png"
          alt="News banner"
          fill
          className="object-cover scale-[1] origin-center"
        />
      </div>

      <div className="absolute z-10 w-full h-[600px] md:h-[450px] bg-[radial-gradient(rgba(4,9,30,0.77),rgba(4,9,30,0.7))]" />

      <div className="md:pt-12 footer-container relative z-20 w-full">
        <div className="row">
          <div className="footer-col"></div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link href="/">Home</Link></li>
              <li><Link href="/about">About Us</Link></li>
              <li><Link href="/academics">Academics</Link></li>
              <li><Link href="/publications">Publications</Link></li>
              <li><Link href="/news">News</Link></li>
              <li><Link href="/gallery">Gallery</Link></li>
              <li><Link href="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Our Socials</h4>
            <div className="social-links">
              <a
                href="https://www.facebook.com/people/Seat-of-Wisdom-Seminary-Umuahia/61573192384934/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-blue-400 transition text-lg"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="YOUR_TIKTOK_URL"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-blue-400 transition text-lg"
              >
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="ml-4 flex flex-col items-start gap-2 pt-4 md:flex-row md:items-center md:justify-between">
          <p className="copyright text-[12px] md:text-[14px] lg:text-[16px]">
            Copyright © 2025 Seat of Wisdom Seminary, Umuahia
          </p>

          <p className="copyright pr-4 text-[12px] opacity-80 md:text-[14px] lg:text-[16px]">
            designed by ël Studios
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
